import { AxiosError } from 'axios'
import store from '@/store'
import { SHOW_RESPONSE_ERROR_DIALOG } from '@/store/action-types'
import VueI18n from 'vue-i18n'
import TranslateResult = VueI18n.TranslateResult

export function showErrorResponseDialog (dialogTitle: string | TranslateResult, errorResponse: AxiosError, infoText?: string |  TranslateResult): void {
  store.dispatch(SHOW_RESPONSE_ERROR_DIALOG, {
    show: true,
    title: dialogTitle,
    errorResponse: errorResponse,
    infoText: infoText
  })
}
